import React from 'react';
import styles from './MultiPose.module.scss';
import fullHeartIcon from '../../../assets/heart.png';
import clearForegrounds from '../../../assets/Clear_Foreground.png';
import useImageOrientation, { ORIENTATION } from '../../../hooks/useImageOrientation';
import cn from 'classnames';

export default function CarouselItem({ favoriteIds, item, useOrientation, onClick, background }) {
  const { orientation } = useImageOrientation(item.watermarkUrl || item.imageUrl);

  return (
    <button
      className={cn(styles.carouselItem, {
        [styles.landscapeItem]: orientation === ORIENTATION.LANDSCAPE,
        [styles.hidden]: useOrientation && orientation !== useOrientation && item.id !== 99999,
      })}
      onClick={onClick}
      type="button"
    >
      {item.id === 99999 ? (
        <img src={clearForegrounds} />
      ) : (
        background ? (
          <>
            <img src={item.watermarkUrl || item.imageUrl} className={styles.carouselImage} />
            <img src={background.imageUrl} className={styles.carouselBackground} />
          </>
        ) : (
          <img src={item.watermarkUrl || item.imageUrl} />
        )
      )}

      {favoriteIds.includes(item.id) && (
        <img alt="Favorite Item" className={styles.favoriteIcon} src={fullHeartIcon} />
      )}
    </button>
  );
}
